const BREAKPOINTS = {
  thumbnail: 156,
  small: 500,
  medium: 750,
  large: 1000,
}

// Don't include originals wider than this in srcSet — prevents
// the browser from downloading multi-MB source files when a
// 1000px "large" format is close enough.
const MAX_SRCSET_WIDTH = 2000

const CDN_ORIGIN = process.env.REACT_APP_CDN_URL
const S3_ORIGIN = process.env.REACT_APP_S3_URL

const toCdnUrl = (imageUrl) => {
  if (!CDN_ORIGIN || !S3_ORIGIN || !imageUrl) return imageUrl
  return imageUrl.replace(S3_ORIGIN, CDN_ORIGIN)
}

const toWebpUrl = (imageUrl) => {
  if (!imageUrl) return null
  return imageUrl.replace(/\.(jpe?g|png)$/i, ".webp")
}

const StrapiImageComponent = ({
  attributes,
  alt,
  className,
  style,
  sizes,
  priority,
}) => {
  if (!attributes) return null

  const { url, formats, alternateText, altText } = attributes
  const fallbackAlt = alt || alternateText || altText || ""
  const isConvertible = /\.(jpe?g|png)$/i.test(url)

  const buildSrcSet = (transformUrl) => {
    if (!formats) return undefined

    const entries = Object.entries(BREAKPOINTS)
      .filter(([key]) => formats[key]?.url)
      .map(([key, width]) => `${transformUrl(formats[key].url)} ${width}w`)

    if (entries.length === 0) return undefined

    if (attributes.width && attributes.width <= MAX_SRCSET_WIDTH) {
      entries.push(`${transformUrl(url)} ${attributes.width}w`)
    }

    return entries.join(", ")
  }

  const srcSet = buildSrcSet(toCdnUrl)
  const webpSrcSet = isConvertible
    ? buildSrcSet((imgUrl) => toWebpUrl(toCdnUrl(imgUrl)))
    : undefined
  const resolvedSizes = srcSet ? sizes || "100vw" : undefined

  return (
    <picture>
      {webpSrcSet && (
        <source type="image/webp" srcSet={webpSrcSet} sizes={resolvedSizes} />
      )}
      <img
        src={toCdnUrl(url)}
        srcSet={srcSet}
        sizes={resolvedSizes}
        alt={fallbackAlt}
        className={className}
        style={{ display: "block", width: "100%", height: "100%", ...style }}
        loading={priority ? "eager" : "lazy"}
        decoding={priority ? "sync" : "async"}
        fetchPriority={priority ? "high" : undefined}
      />
    </picture>
  )
}

export default StrapiImageComponent
